import striveMark from './assets/strive-mark.png';
import React from 'react';
import RideInfo from './RideInfo';
import './join-screen.css';
import './feedback.css';

export const RECHECK_NOTICE = 'Re-checking that you’re still in the car… keep this page open.';

// Lock grace for a rider who already had the remote: a status line above the live controls.
export function PresenceRecheckNotice() {
  return <div className="connection-notice presence-recheck-notice" role="status" aria-live="polite">
    <span className="remote-loading-spinner" aria-hidden="true" />
    <span>{RECHECK_NOTICE}</span>
  </div>;
}

// Neutral wait while the driver app first verifies presence; never a lock screen.
export default function PresenceCheck() {
  return <div className="join-screen presence-check">
    <header className="join-header"><div className="brand-section"><img className="brand-logo" src={striveMark} alt="" width="27" height="27" /><span className="brand-text">strive<span className="brand-domain">.fm</span></span></div><RideInfo showLabel /></header>
    <main className="join-main" role="status" aria-live="polite">
      <div className="join-location-icon" aria-hidden="true"><span className="remote-loading-spinner" /></div>
      <h1>Connecting you to the car…</h1>
      <p className="join-intro">Checking that you’re near your driver. This takes a few seconds.</p>
    </main>
    <div className="join-waves" aria-hidden="true">
      <svg viewBox="0 24 150 28" preserveAspectRatio="none" focusable="false">
        <defs>
          <path id="presence-gentle-wave" d="M-160 44c30 0 58-18 88-18s58 18 88 18 58-18 88-18 58 18 88 18v44h-352z" />
        </defs>
        <use href="#presence-gentle-wave" x="50" y="0" />
        <use href="#presence-gentle-wave" x="50" y="3" />
        <use href="#presence-gentle-wave" x="50" y="6" />
      </svg>
    </div>
  </div>;
}
